import React, { useEffect, useState } from "react";
// import orderbannerimg from "../../assets/images/order-banner-img2.png";
import backicon from "../../assets/images/close-icon.svg";
import deleteicon from "../../assets/images/delete-icon.svg";
import plusicon from "../../assets/images/plus-icon.svg";
import plusicons from "../../assets/images/plus-icon2.svg";
import plusicon5 from "../../assets/images/plus_icon5.svg";
import minusicon from "../../assets/images/minus_icon.svg";
import minusIcon from "../../assets/images/minus_icon.png";
import checkicon from "../../assets/images/check_icon.svg";
import { useNavigate, useParams, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { orderingActions, cartActions } from "../../_actions";
import { Modal } from "react-bootstrap";
import CustomLoader from "../../components/CustomeLoader";
import { alert } from "../../_utilities";
import BottomNav from "../../components/BottomNav";
import ShopCloseModel from "../../components/ShopCloseModel";
function ProductDetails() {
  const params = useParams();
  const location = useLocation();
  const state = location.state;
  const fromProductId = location.state?.fromProductId;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(true);
  let [productDetails, setProductDetails] = useState({});
  let [relatedItems, setRelatedItems] = useState([]);
  let [product, setProduct] = useState({});
  const [total, setTotal] = useState(0);
  const [isShopIsClosed, setIsShopIsClosed] = useState(false);

  // const productDetail = useSelector(
  //   (state) => state?.orderingList?.product_details_data?.item
  // );
  const prevCartData = useSelector((state) => state?.cartList?.cart_list_data);

  const configData = localStorage.getItem("configData")
    ? JSON.parse(localStorage.getItem("configData"))
    : null;

  const handleModalOpen = () => {
    setModal(true);
  };

  const calculateTotal = (cartData) => {
    let cartTotalAmount = cartData.reduce((total, item) => {
      const basePrice =
        item.special_price == 0 ? item.price : item.special_price;
      const itemTotal = basePrice * item.quantity;

      const optionsTotal = item.option_groups.reduce((optionsSum, group) => {
        return group.options.reduce((groupSum, option) => {
          if (option.isSelected === true) {
            let quantity = option?.quantity || 1;
            groupSum = groupSum + option.price * quantity;
          }
          return groupSum;
        }, optionsSum);
      }, 0);

      return total + itemTotal + optionsTotal;
    }, 0);
    return Number(cartTotalAmount.toFixed(2));
    // .toFixed(2);
  };

  useEffect(() => {
    let itemInCart = null;
    if (prevCartData?.cartData?.length > 0) {
      itemInCart = prevCartData.cartData.filter(({ id }) => {
        return id === Number(params.menu_id);
      });
      itemInCart = itemInCart[0] || null;
    }
    if (state && state.order && state.order?.id) {
      if (itemInCart) {
        setProductDetails({ ...itemInCart });
        setTotal(itemInCart?.total);
        setLoading(false);
      } else {
        setProductDetails({ quantity: 1, ...state.order });
        setTotal(
          state.order.special_price == 0
            ? state.order.price
            : state.order.special_price
        );
        setLoading(false);
      }
    } else {
      if (params.menu_id) {
        dispatch(orderingActions?.getProductDetails({ id: params.menu_id }));
        // setIsLodaer(true);
      }
    }
    if (params.store_id) {
      localStorage.setItem("outlet_id", params.store_id);
    }
  }, [params.menu_id, params.store_id, prevCartData]);

  const handleAdd = (item = false, option_groups_index, index) => {
    if (item === true) {
      setProductDetails({
        ...productDetails,
        quantity: productDetails.quantity + 1,
      });
      setTotal(
        productDetails.special_price == 0
          ? total + productDetails.price
          : total + productDetails.special_price
      );
    } else {
      if (
        productDetails.option_groups[option_groups_index].is_required == true
      ) {
        if (
          productDetails.option_groups[option_groups_index].options[index]
            .isSelected == true
        ) {
          productDetails.option_groups[option_groups_index].options[
            index
          ].quantity =
            productDetails.option_groups[option_groups_index].options[index]
              ?.quantity + 1 || 1;
          setTotal(
            total +
              productDetails.option_groups[option_groups_index].options[index]
                .price
          );
        }
      } else {
        const selectedOption =
          productDetails.option_groups[option_groups_index].options[index];

        if (selectedOption.isSelected) {
          productDetails.option_groups[option_groups_index].options[
            index
          ].quantity =
            productDetails.option_groups[option_groups_index].options[index]
              ?.quantity + 1 || 1;
          setTotal(
            total +
              productDetails.option_groups[option_groups_index].options[index]
                .price
          );
        }
      }
    }
  };

  const handleRemove = (item = false, option_groups_index = -1, index = -1) => {
    if (item === true && productDetails?.quantity > 1) {
      setProductDetails({
        ...productDetails,
        quantity: productDetails.quantity - 1,
      });
      setTotal(
        total - productDetails.special_price == 0
          ? productDetails.price
          : productDetails.special_price
      );
    }
    if (index >= 0 && option_groups_index >= 0) {
      const optionGroup = productDetails.option_groups[option_groups_index];
      const option = optionGroup.options[index];

      if (optionGroup.is_required === true) {
        if (option.isSelected === true && option.quantity > 1) {
          option.quantity -= 1;
          setTotal(total - option.price);
        } else if (option.isSelected === true && option.quantity === 1) {
          option.quantity -= 1;
          option.isSelected = false;
          setTotal(total - option.price);
        }
      } else {
        option.quantity -= 1;
        if (option.quantity === 0) {
          option.isSelected = false;
        }
        setTotal(total - option.price);
      }

      setProductDetails({ ...productDetails });
    }
  };

  const handleCheckBox = (e, option_groups, i) => {
    const { checked } = e.target;
    if (checked === true) {
      productDetails.option_groups[option_groups].options[i].isSelected =
        checked;

      setTotal(
        total + productDetails.option_groups[option_groups].options[i].price
      );
      handleAdd(false, option_groups, i);
    } else {
      if (
        productDetails.option_groups[option_groups].options[i]?.quantity <= 1
      ) {
        productDetails.option_groups[option_groups].options[i].isSelected =
          checked;
      }
      setTotal(
        total - productDetails.option_groups[option_groups].options[i].price
      );
      handleRemove(false, option_groups, i);
    }
    setProductDetails({ ...productDetails });
  };

  const handleRadioButtonEvent = (mainData, option_groups_index, index) => {
    let optionGroup = mainData.option_groups[option_groups_index];
    let selectedOption = optionGroup.options[index];

    let option_total_quantity = optionGroup.options.reduce(
      (sum, option) => sum + (option.quantity || 0),
      0
    );
    if (option_total_quantity < mainData.quantity) {
      let previousQuantity = selectedOption.quantity || 0;
      let newQuantity = previousQuantity + 1;

      selectedOption.quantity = newQuantity;
      selectedOption.isSelected = true;

      setProductDetails({ ...productDetails });
      setTotal((prevTotal) => prevTotal + selectedOption.price);
    }
  };

  const handleRadioButtonRemoveEvent = (
    mainData,
    option_groups_index,
    index
  ) => {
    let optionGroup = mainData.option_groups[option_groups_index];
    let selectedOption = optionGroup.options[index];
    selectedOption.quantity =
      selectedOption.quantity >= 1 ? selectedOption.quantity - 1 : 0;
    if (selectedOption.quantity === 0) {
      selectedOption.isSelected = false;
    }
    setProductDetails({ ...productDetails });
    setTotal((prevTotal) => prevTotal - selectedOption.price);
  };

  const handleProps = () => {
    if (productDetails && productDetails.option_groups) {
      const requiredGroup =
        productDetails.option_groups.length > 0 &&
        productDetails.option_groups.find(
          (group) => group.is_required === 1 && group.name !== "Removals"
        );
      const isAnyOptionSelected =
        requiredGroup &&
        requiredGroup.options.some((option) => option.isSelected);

      if (requiredGroup && !isAnyOptionSelected) {
        alert.error("Item is required");
        return false;
      }

      let optionTotal = 0;
      let totalOptionQuantity = 0;
      let optionType = "";
      for (const option of productDetails.option_groups) {
        if (option.name !== "Removals") {
          optionType = option.type;
          for (const element of option.options) {
            optionTotal = optionTotal + element.quantity * element.price;
            totalOptionQuantity = element.quantity
              ? totalOptionQuantity + element.quantity
              : totalOptionQuantity;
          }
        }
      }
      if (
        optionType === "multiple" ||
        productDetails?.option_groups.length == 0
      ) {
        updateDetailPageData();
      } else if (productDetails?.option_groups.length > 0) {
        if (totalOptionQuantity === productDetails?.quantity) {
          updateDetailPageData();
        } else {
          alert.error("Product quantity and options quantity should be same");
        }
      }
    }
  };

  const updateDetailPageData = () => {
    let updatedCartData = [];
    let showCartMessage = false;
    if (prevCartData?.cartData?.length > 0) {
      const existingProductIndex = prevCartData.cartData.findIndex((item) => {
        const isSameProduct = item.id === productDetails.id;

        if (isSameProduct) {
          const isSameOptions = item.option_groups.every(
            (group, groupIndex) => {
              return group.options.every((option, optionIndex) => {
                return (
                  option.isSelected ===
                    productDetails.option_groups[groupIndex].options[
                      optionIndex
                    ].isSelected &&
                  option.quantity ===
                    productDetails.option_groups[groupIndex].options[
                      optionIndex
                    ].quantity
                );
              });
            }
          );
          return isSameProduct && isSameOptions;
        }
      });
      if (existingProductIndex > -1) {
        const existingProduct = prevCartData.cartData[existingProductIndex];
        let updatedProduct = {};
        if (existingProduct?.option_groups.length > 0) {
          let option_total = 0;
          for (const optiongroup of existingProduct?.option_groups) {
            optiongroup?.options.filter((item, id) => {
              if (item.isSelected === true) {
                option_total = option_total + item.quantity * item.price;
              }
            });
          }
          updatedProduct = {
            ...existingProduct,
            quantity: productDetails.quantity,
            total:
              productDetails.special_price == 0
                ? productDetails.quantity * productDetails.price + option_total
                : productDetails.quantity * productDetails.special_price +
                  option_total,
          };
        } else {
          updatedProduct = {
            ...existingProduct,
            quantity: productDetails.quantity,
            total:
              productDetails.special_price == 0
                ? productDetails.quantity * productDetails.price
                : productDetails.quantity * productDetails.special_price,
          };
        }

        updatedCartData = prevCartData.cartData.map((item) =>
          item.id === updatedProduct.id ? { ...updatedProduct, total } : item
        );
      } else {
        showCartMessage = true;
        updatedCartData = [
          ...prevCartData.cartData,
          { ...productDetails, total: total },
        ];
      }
      dispatch(
        cartActions.updateCart({
          message: showCartMessage ? `Cart updated successfully` : undefined,
          cartData: {
            outlet_id: params.store_id,
            cartData: [...updatedCartData, ...relatedItems],
            totalAmount: calculateTotal([...updatedCartData, ...relatedItems]),
          },
        })
      );
    } else {
      dispatch(
        cartActions.updateCart({
          message: `Cart updated successfully`,
          cartData: {
            outlet_id: params.store_id,
            cartData: [{ ...productDetails, total: total }, ...relatedItems],
            totalAmount: total,
          },
        })
      );
    }
    // navigate("/menu");
    // navigate("/menu", { state: { scrollToProductId: fromProductId } });
    navigate(-1);
    return;
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  const isFromAppView =
    localStorage.getItem("isAppView") != "isAppView"
      ? JSON.parse(localStorage.getItem("isAppView"))
      : null;

  const handleBack = () => {
    navigate(-1);
    // navigate("/menu", { state: { scrollToProductId: fromProductId } });
  };
  return (
    <>
      <div className="main-wrapper" id="product-details-page">
        <CustomLoader loading={loading} />
        {!loading && (
          <div
            className="product-details"
            style={{
              marginBottom:
                productDetails && productDetails?.photo ? "0px" : "0px",
            }}
          >
            {productDetails?.photo ? (
              <div className="product-details-img">
                <img src={productDetails?.photo} alt="" />
              </div>
            ) : (
              <div style={{ height: "100px" }}></div>
            )}
            <div className="container">
              <div className="content">
                {/* <a href="/menu" title="back" className="back-link">
                  <img src={backicon} alt="" />
                </a> */}
                <a title="back" className="back-link" onClick={handleBack}>
                  <img src={backicon} alt="" />
                </a>
                {/* <button type="text" className="btn-primary">
                  NEW DEAL
                </button> */}
              </div>
            </div>
            <div className="product-container">
              <div className="container">
                <div className="product-content">
                  {productDetails?.name && <h2>{productDetails?.name}</h2>}
                  <h6>
                    {productDetails?.special_price != 0
                      ? `£${productDetails?.special_price?.toFixed(2)}`
                      : `£${productDetails?.price?.toFixed(2)}`}
                    {productDetails?.special_price != 0 && (
                      <span
                        style={{
                          textDecoration: "line-through",
                          marginLeft: "10px",
                          fontSize: "14px",
                          lineHeight: "18px",
                          fontFamily: "sans-serif",
                          color: "#343434",
                          marginBottom: 0,
                          fontWeight: "bold",
                        }}
                      >{`£${productDetails?.price?.toFixed(2)}`}</span>
                    )}
                  </h6>
                  {productDetails?.description && (
                    <p>{productDetails?.description}</p>
                  )}
                  <div className="icon">
                    <img
                      className={` ${
                        productDetails?.quantity > 1 ? "minus_icon" : ""
                      } delete_icon`}
                      src={
                        productDetails?.quantity > 1 ? minusIcon : deleteicon
                      }
                      alt=""
                      style={{ cursor: "pointer" }}
                      onClick={() => handleRemove(true)}
                    />
                    <h3>{productDetails?.quantity}</h3>
                    <img
                      src={plusicon}
                      alt=""
                      onClick={() => handleAdd(true)}
                      className="plus-icon"
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </div>
                {productDetails?.option_groups?.length > 0 && (
                  <>
                    {productDetails?.option_groups.map(
                      (optionGroup, option_group_index) => {
                        return (
                          <div
                            className="product-content"
                            key={`product-content-${option_group_index}`}
                          >
                            <h6
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              {optionGroup?.name}
                              {optionGroup?.name === "Removals"
                                ? null
                                : optionGroup.is_required === 1 && (
                                    <div
                                      className={`required ${
                                        product.quantity === 0 ||
                                        !optionGroup.options.some(
                                          (option) => option.isSelected
                                        )
                                          ? "disabled"
                                          : ""
                                      }`}
                                    >
                                      <button>
                                        {optionGroup.options.some(
                                          (option) => option.isSelected
                                        ) && <img src={checkicon} alt="" />}
                                        Required
                                      </button>
                                    </div>
                                  )}
                            </h6>

                            {/* <h6 style={{ display: "flex", justifyContent: 'space-between', }}>{optionGroup?.name}
                              {optionGroup?.name == "Removals" ? <></> : optionGroup.is_required == 1 && <div className={`required ${isDisabled ? 'disabled' : ''}`}>
                                <button>
                                  {!isDisabled && <img src={checkicon} alt="" />}
                                  Required
                                </button>
                              </div>}
                            </h6> */}
                            {optionGroup?.options &&
                              optionGroup?.options?.length > 0 &&
                              optionGroup?.options.map((item, option_index) => (
                                <div
                                  className="choose-box"
                                  key={`option_index_${option_index}`}
                                >
                                  <div className="choose-content">
                                    <div className="radio_icon">
                                      {optionGroup?.type === "multiple" && (
                                        <input
                                          value={item?.isSelected}
                                          type="checkbox"
                                          checked={item?.isSelected}
                                          onChange={(e) => {
                                            handleCheckBox(
                                              e,
                                              option_group_index,
                                              option_index
                                            );
                                          }}
                                        />
                                      )}
                                      <div
                                        className=""
                                        style={{ marginLeft: "10px" }}
                                      >
                                        <h5>{item.name}</h5>
                                        <h5>£{item.price?.toFixed(2)}</h5>
                                      </div>
                                    </div>
                                    {/* <p>1 kcal</p> */}
                                  </div>
                                  {
                                    <div className="choose-icon">
                                      {item?.quantity > 0 && (
                                        <img
                                          src={minusicon}
                                          alt=""
                                          style={{ cursor: "pointer" }}
                                          onClick={
                                            () =>
                                              handleRadioButtonRemoveEvent(
                                                productDetails,
                                                option_group_index,
                                                option_index
                                              )
                                            // handleRemove(
                                            //   false,
                                            //   option_group_index,
                                            //   option_index
                                            // )
                                          }
                                        />
                                      )}
                                      {item?.quantity > 0 && (
                                        <h3>{item.quantity}</h3>
                                      )}
                                      {optionGroup?.name != "Removals" && (
                                        <img
                                          src={plusicons}
                                          alt=""
                                          className="plus-icon"
                                          style={{ cursor: "pointer" }}
                                          onClick={(e) => {
                                            handleRadioButtonEvent(
                                              productDetails,
                                              option_group_index,
                                              option_index
                                            );
                                          }}
                                        />
                                      )}
                                    </div>
                                  }
                                </div>
                              ))}
                          </div>
                        );
                      }
                    )}
                  </>
                )}

                <div className="add-order-btn">
                  <button
                    type="text"
                    className="btn-primary"
                    onClick={() => {
                      if (configData && configData.IsShopClosed == "1") {
                        setIsShopIsClosed(true);
                      } else {
                        handleProps();
                      }
                    }}
                  >
                    Add {productDetails.quantity} to order • £
                    {total?.toFixed(2)}
                    {/* {total} */}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {isFromAppView && <BottomNav class={"icon-menu"} />}
        {isShopIsClosed && (
          <ShopCloseModel setIsShopIsClosed={setIsShopIsClosed} />
        )}
      </div>
    </>
  );
}
export default ProductDetails;

// {productDetails?.related_items?.length > 0 && (
//   <>
//     <div className="product-content">
//       <h6>Related Items</h6>
//       {productDetails?.related_items.map(
//         (related_item, related_items_index) => {
//           return (
//             <div
//               className="choose-box"
//               key={`procuct_${related_items_index}`}
//             >
//               <div className="choose-content">
//                 {/* {related_item?.type === "multiple" ? (
//               <input
//                 value={"Extra Patty"}
//                 type="checkbox"
//                 checked={item.isSelected}
//                 onChange={(e) => {
//                   handleCheckBox(
//                     e,
//                     option_group_index,
//                     option_index
//                   );
//                 }}
//               />
//             ) : ( */}
//                 {/* <input
//               type="radio"
//               value={optionGroup?.name}
//               checked={item.isSelected}
//               name={optionGroup?.name}
//               onChange={(e) => {
//                 handleRadioButton(
//                   e,
//                   option_group_index,
//                   option_index
//                 );
//               }}
//             /> */}
//                 {/* )} */}

//                 <h5>{related_item.name}</h5>
//                 <h5>£{related_item.price?.toFixed(2)}</h5>
//                 {/* <p>1 kcal</p> */}
//               </div>
//               {related_item?.price > 0 && (
//                 <div className="choose-icon">
//                   {related_item?.quantity > 0 && (
//                     <img
//                       src={minusicon}
//                       alt=""
//                       style={{ cursor: "pointer" }}
//                       onClick={(e) => {
//                         if (
//                           related_item.has_required_option_group ===
//                           true
//                         ) {
//                           handleModalOpen();
//                           let product = {
//                             ...related_item,
//                             quantity: 1,
//                             amount: related_item?.price,
//                           };
//                           setProduct(
//                             ...JSON.parse(
//                               JSON.stringify(product)
//                             )
//                           );
//                         } else {
//                           productDetails.related_items[
//                             related_items_index
//                           ]["quantity"] =
//                             productDetails.related_items[
//                               related_items_index
//                             ]["quantity"] - 1 || 0;
//                           productDetails.related_items[
//                             related_items_index
//                           ]["total"] =
//                             productDetails.related_items[
//                               related_items_index
//                             ]["total"] - related_item?.price ||
//                             0;

//                           setProductDetails({
//                             ...productDetails,
//                           });
//                           setTotal(total - related_item?.price);
//                           let isProductExist = relatedItems?.filter(
//                             (item) =>
//                               item.id === related_item.id
//                           );
//                           if (isProductExist?.length > 0) {
//                             relatedItems = relatedItems.map(
//                               (item) => {
//                                 if (
//                                   item.id === related_item.id
//                                 ) {
//                                   return {
//                                     ...item,
//                                     quantity: item.quantity - 1,
//                                     total:
//                                       item.total - item.price,
//                                   };
//                                 } else {
//                                   return item;
//                                 }
//                               }
//                             );
//                             relatedItems = relatedItems.filter(
//                               (item, index) => item.quantity > 0
//                             );

//                             setRelatedItems([...relatedItems]);
//                           } else {
//                             setRelatedItems((prev) => {
//                               return [
//                                 {
//                                   ...related_item,
//                                   quantity: 1,
//                                   total: related_item?.price,
//                                 },
//                                 ...prev,
//                               ];
//                             });
//                           }
//                         }
//                       }}
//                     />
//                   )}
//                   {related_item?.quantity > 0 && (
//                     <h3>{related_item.quantity}</h3>
//                   )}
//                   {related_item.is_in_stock == 1 ? (
//                     <img
//                       src={plusicons}
//                       alt=""
//                       className="plus-icon"
//                       style={{ cursor: "pointer" }}
//                       onClick={(e) => {
//                         if (
//                           related_item.has_required_option_group ===
//                           true
//                         ) {
//                           handleModalOpen();
//                           let product = {
//                             ...related_item,
//                             quantity: 1,
//                             amount: related_item?.price,
//                           };
//                           setProduct(product);
//                         } else {
//                           productDetails.related_items[
//                             related_items_index
//                           ]["quantity"] =
//                             productDetails.related_items[
//                               related_items_index
//                             ]["quantity"] + 1 || 1;
//                           productDetails.related_items[
//                             related_items_index
//                           ]["total"] =
//                             productDetails.related_items[
//                               related_items_index
//                             ]["total"] + related_item?.price ||
//                             related_item?.price;

//                           setProductDetails({
//                             ...productDetails,
//                           });
//                           setTotal(total + related_item?.price);
//                           let isProductExist = relatedItems?.filter(
//                             (item) =>
//                               item.id === related_item.id
//                           );
//                           if (isProductExist?.length > 0) {
//                             relatedItems = relatedItems.map(
//                               (item) => {
//                                 if (
//                                   item.id === related_item.id
//                                 ) {
//                                   return {
//                                     ...item,
//                                     quantity: item.quantity + 1,
//                                     total:
//                                       item.total + item.price,
//                                   };
//                                 } else {
//                                   return item;
//                                 }
//                               }
//                             );
//                             setRelatedItems([...relatedItems]);
//                           } else {
//                             setRelatedItems((prev) => {
//                               return [
//                                 {
//                                   ...related_item,
//                                   quantity: 1,
//                                   total: related_item?.price,
//                                 },
//                                 ...prev,
//                               ];
//                             });
//                           }
//                         }
//                       }}
//                     />
//                   ) : (
//                     <p style={{ marginTop: 15 }}>SOLD OUT</p>
//                   )}
//                 </div>
//               )}
//             </div>
//           );
//         }
//       )}
//     </div>
//   </>
// )}
